import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=75e4168b&"
import script from "./Heading.vue?vue&type=script&lang=js&"
export * from "./Heading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\DevOpsAgent\\agent1\\_work\\10\\s\\Site\\Source\\Web\\Marketing.UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75e4168b')) {
      api.createRecord('75e4168b', component.options)
    } else {
      api.reload('75e4168b', component.options)
    }
    module.hot.accept("./Heading.vue?vue&type=template&id=75e4168b&", function () {
      api.rerender('75e4168b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Views/Marketing/ProForm/components/shared/Heading.vue"
export default component.exports